import React from 'react'
import './print.css'
const Print = (props) => {
    
    const { state } = props.location

    if(!state) return null
    
    return (
        <>
        <button id="printPageButton" onClick={() => window.print()}>Print</button>

        {
            state.map((repo, index) => 
            <div style={{marginTop:50}} key={index}>
            <h4>Program Studi: {repo.name}</h4>                    
            <table className="print" style={{tableLayout: 'auto', width:'100%'}}>
                <thead>
                    <tr>
                        <th rowSpan="2">No</th>                                
                        <th rowSpan="2">Nama Surat</th>                        
                        <th colSpan="4">Aksi</th>
                    </tr>
                    <tr>
                        <th>Masuk</th>
                        <th>Sedang Diproses</th>
                        <th>Selesai</th>
                        <th>Ditolak</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        repo.total.map((repo, index) => 
                            <tr key={index}>
                                <td>{index+1}</td>                                        
                                <td>{repo.letter_name}</td>                               
                                <td style={{textAlign:'center'}}>{repo.total.submitted}</td>
                                <td style={{textAlign:'center'}}>{repo.total.processed}</td>
                                <td style={{textAlign:'center'}}>{repo.total.finished}</td>
                                <td style={{textAlign:'center'}}>{repo.total.rejected}</td>
                            </tr>)
                    }
                </tbody>
            </table>
            </div>
            )
        }       
        </>
    )
}


export default Print